import Hint from '../../../../../components/common/Hint';

/**
 * The per-image actions (crop, rotate, copy, delete) as a hover bar.
 *
 * It lives over the picture itself — on a grid card or on a single large
 * preview — so the edits are where the image is rather than in the file list.
 * The parent needs `group relative`; on touch, where there is no hover, the bar
 * stays visible.
 */
// Each tool gets its own tint, so the bar reads at a glance instead of as four
// identical white pills — and delete is unmistakably the red one. An action with
// no entry here (a tool-specific button) keeps the neutral look.
const ACTION_TONE = {
    crop: 'text-amber-600 hover:bg-amber-50 dark:text-amber-400 dark:hover:bg-amber-950/40',
    rotate: 'text-sky-600 hover:bg-sky-50 dark:text-sky-400 dark:hover:bg-sky-950/40',
    duplicate: 'text-violet-600 hover:bg-violet-50 dark:text-violet-400 dark:hover:bg-violet-950/40',
    download: 'text-emerald-600 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-950/40',
    delete: 'text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/40',
};

const NEUTRAL_TONE = 'text-[#3D3833] hover:bg-white dark:text-zinc-100 dark:hover:bg-zinc-800';

export default function ImageActionOverlay({ actions = [], index = 0, className = '' }) {
    if (!actions.length) return null;

    return (
        <div
            className={`absolute inset-x-0 bottom-0 z-10 flex items-center justify-center gap-1.5 bg-gradient-to-t from-[#1C1815]/75 to-transparent px-2 pb-2 pt-8 transition-opacity md:opacity-0 md:group-hover:opacity-100 ${className}`}
        >
            {actions.map(({ id, icon: Icon, label, onClick, disabled }) => (
                <Hint label={label} key={id}>
                    <button
                        type="button"
                        aria-label={label}
                        disabled={disabled}
                        onClick={(e) => { e.stopPropagation(); onClick(index); }}
                        className={`flex h-8 w-8 items-center justify-center rounded-lg bg-white/95 shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50 dark:bg-zinc-800/95 ${ACTION_TONE[id] || NEUTRAL_TONE}`}
                    >
                        <Icon size={15} stroke={1.9} />
                    </button>
                </Hint>
            ))}
        </div>
    );
}
